import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ShortTests from '../shorts/Tests';
import ShortNews from '../shorts/News';
import { Helmet } from 'react-helmet-async';
import AdSlot from '../ads/AdSlot';

import '../../assets/css/contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('Senden...');

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setStatus('Nachricht erfolgreich gesendet!');
                setFormData({ name: '', email: '', message: '' });
            } else {
                setStatus('Fehler beim Senden.');
            }
        } catch (error) {
            console.error('Fehler:', error);
            setStatus('Serverfehler.');
        }
    };

    const pageTitle = 'Kontakt | NGCTV';
    const pageDescription = 'Nimm Kontakt zur NGCTV-Redaktion auf – Fragen, Anregungen und Feedback rund um ngctv.de.';

    return (
        <>
            {/* SEO / Head */}
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href={`https://ngctv.de/contact`} />
            </Helmet>

            <main>
                <div className='wrapper'>
                    <div className='rows'>
                        <div className='row contact-row'>
                            <div className='category'>Kontakt</div>
                            <div className="contact">
                                <div className='contact-info'>
                                    <h1>Mit NGCTV in Kontakt treten</h1>
                                    <p>Wenn du Fragen oder Anregungen zu ngctv.de hast, kannst du uns über das Formular erreichen.</p>
                                </div>

                                <div className='contact-form'>
                                    <h2>Kontakt zur Redaktion</h2>
                                    <form onSubmit={handleSubmit}>
                                        <div className='input-group'>
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className='input-group'>
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className='input-group'>
                                            <label>Nachricht</label>
                                            <textarea
                                                name="message"
                                                rows="5"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            ></textarea>
                                        </div>
                                        <button className="btn btn-primary" type="submit">Senden</button>
                                    </form>
                                    {status && <p>{status}</p>}
                                </div>

                                <hr />

                                <div className='contact-foren'>
                                    <h2>Foren</h2>
                                    <p>Du kannst uns deine Meinung, Wünsche und Anregungen auch direkt im Forum hinterlassen.</p><br />
                                    Zum Forum: <Link to="/community/Meinungen%20zu%20ngctv.de">Meinungen zu ngctv.de</Link><br />
                                    Wenn du Fragen, Kritik oder Wünsche zur Website hast, ist hier der Platz dafür.
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <ShortTests />
                            <ShortNews />
                            <AdSlot slot="2119524913" />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Contact;
